import React, { forwardRef } from 'react';

import { POST_AUTHOR_ARTICLES_ID } from '../../constants';
import * as s from './PostAuthorArticlesLayout.css';

export interface IPostAuthorArticlesLayout {
  articles: React.ReactNode;
  pagination: React.ReactNode;
}

/**
 * Декоратор для AuthorArticlesNewContainer
 */
export const PostAuthorArticlesLayout = forwardRef<HTMLDivElement, IPostAuthorArticlesLayout>(
  ({ articles, pagination }, ref) => (
    <div id={POST_AUTHOR_ARTICLES_ID} ref={ref} className={s['wrapper']}>
      <div className={s['articles-wrapper']}>{articles}</div>
      <div className={s['pagination-wrapper']}>{pagination}</div>
    </div>
  ),
);

PostAuthorArticlesLayout.displayName = 'PostAuthorArticlesLayout';
